export const resizableColumn = (id) => {
  const table = document.getElementById(id);
  if (table) {
      const cols = table.querySelectorAll('th');
      cols.forEach((col) => {
          if (!isFixedColumn(col)) {
              const resizer = getOrCreateResizer(col);
              setColumnWidth(col);
              col.appendChild(resizer);
              createResizableColumn(col, resizer);
          }
      });
  }
};

const isFixedColumn = (col) => {
  return col?.classList?.contains('fixed');
};

const getOrCreateResizer = (col) => {
  if (col.children[1]?.classList.contains('resizer')) {
      return col.children[1];
  } else {
      const resizer = document.createElement('div');
      resizer.classList.add('resizer');
      return resizer;
  }
};

const setColumnWidth = (col) => {
  if (!col.style.width) {
      const styles = window.getComputedStyle(col);
      let width = parseInt(styles.width, 10);
      if (width === 0) {
          width = 100;
      }
      col.style.width = `${width}px`;
  }
};

const createResizableColumn = (col, resizer) => {
  let x = 0;
  let w = 0;

  const mouseDownHandler = (e) => {
      x = e.clientX;
      const styles = window.getComputedStyle(col);
      w = parseInt(styles.width, 10);
      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
      resizer.classList.add('resizing');
  };

  const mouseMoveHandler = (e) => {
      const dx = e.clientX - x;
      if ((w + dx) > 50) {
          col.style.width = `${w + dx}px`;
      }
  };

  const mouseUpHandler = () => {
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
      resizer.classList.remove('resizing');
  };

  resizer.addEventListener('mousedown', mouseDownHandler);
};